import React, { useEffect } from "react"
import { PauseCircle, PlayCircle } from "react-bootstrap-icons"
import { useDispatch, useSelector } from "react-redux"
import { prependAndPlay, playOrPause } from "../../stores/mediaPlayerSlice"
import { useInfiniteBandPosts } from "../../hooks/useBandPosts"

const PreviewPlayer = ({
  bandId,
  width = "30%",
  height = "30%",
  className = "text-white",
}) => {
  const dispatch = useDispatch()
  const currentMediaItem = useSelector(
    (state) => state.mediaPlayer.value.currentMediaItem,
  )
  const playerState = useSelector(
    (state) => state.mediaPlayer.value.playerState,
  )
  const isCurrentlyPlaying =
    playerState === "playing" && currentMediaItem?.bandId === bandId
  const isCurrentlyQueued =
    playerState === "paused" && currentMediaItem?.bandId === bandId

  const { data, status, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteBandPosts({
      bandId,
      contentType: "songs",
      adminMode: false,
      pageSize: 100,
    })

  // Eagerly fetch all pages so the play button has the full catalog
  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage()
    }
  }, [hasNextPage, isFetchingNextPage, fetchNextPage])

  if (status === "loading" || !data) return null

  const allSongs = data.pages.flatMap((page) => page.posts)

  if (allSongs.length === 0) return null

  const onPlayClick = () => dispatch(prependAndPlay(allSongs))
  const onPlayOrPauseClick = () => dispatch(playOrPause())

  return isCurrentlyPlaying ? (
    <PauseCircle
      className={`cursor-pointer ${className}`}
      width={width}
      height={height}
      onClick={onPlayOrPauseClick}
    />
  ) : (
    <PlayCircle
      className={`cursor-pointer ${className}`}
      width={width}
      height={height}
      onClick={isCurrentlyQueued ? onPlayOrPauseClick : onPlayClick}
    />
  )
}

export default PreviewPlayer
